module.exports = __webpack_public_path__ + "assets/rigger.svg?b15fe358bea0bca97717263803d55c6c";